module.exports = __webpack_public_path__ + "static/media/ogg-icon.70fc1f69.svg";